export const CLIENT_HOMEPAGE_MARKETING_VIDEO_MODULE_FLAG_NAME: (slot: string) => string = (
  slot: string,
) => (
  `client_${slot}_marketing_video_module_20220512`
);
